import { Modal, Spinner } from "react-bootstrap";

const ModalFetching = ({ loading, setLoading, text }) => {
	return (
		<Modal show={loading} onHide={() => setLoading(false)} backdrop="static" keyboard={false} centered>
			<div>
				<Modal.Header style={{ borderBottom: "inherit" }}>
					<Modal.Title style={{ fontSize: "1em" }}>{text}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div
						style={{
							textAlign: "center",
						}}
					>
						<Spinner animation="grow" variant="success" />
					</div>
				</Modal.Body>
			</div>
		</Modal>
	);
};

export default ModalFetching;
